import { i18nMark } from 'lingui-react';

const messages = {
  cancelButton: i18nMark('Cancel'),
  editButton: i18nMark('Edit'),
  keypressGuide: i18nMark('Press ESC to cancel or ENTER to submit'),
  submitButton: i18nMark('Submit Request'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/WizardSteps/Review/messages.js